import { Component } from '@angular/core';

@Component({
  selector: 'op-exchange-currency',
  templateUrl: './exchange-currency.component.html'
})
export class ExchangeCurrencyComponent {
}
